const environment = import.meta.env.VITE_APP_ENV || import.meta.env.MODE;
const apiUrl = import.meta.env.VITE_API_URL;

const allowedEnvironments = ['development', 'staging', 'production'];

if (!allowedEnvironments.includes(environment)) {
  throw new Error(`Environnement invalide : ${environment}`);
}

if (!apiUrl) {
  throw new Error('VITE_API_URL est obligatoire.');
}

const env = {
  apiUrl,
  baseUrlApi: import.meta.env.VITE_BASE_URL_API,
  baseUrlApiStg: 'https://api-staging.moovicar.com',
  googleMapsKey: import.meta.env.VITE_GOOGLE_MAPS_KEY,
  mapboxToken: import.meta.env.VITE_MAPBOX_TOKEN,
  cartoApiKey: import.meta.env.VITE_CARTO_API_KEY,
  mapboxStyle: import.meta.env.VITE_MAPBOX_STYLE,
  mapboxToken2: import.meta.env.VITE_MAPBOX_TOKEN2,
  stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
  isDevelopment: environment === 'development',
  isStaging: environment === 'staging',
  isProduction: environment === 'production',
};

export default env;
